import useMetamaskButton from "@casino/legacy/client/features/Metamask/modules/MetamaskAuthButton/useMetamaskButton/useMetamaskButton";
import useRouter from "@casino/legacy/client/hooks/router/useRouter";
import useLanguage from "@casino/legacy/client/hooks/useLanguage";
import useUserGeoLocation from "@casino/legacyUi/form/FormPhoneNumber/hooks/useUserGeoLocation";
import { cn } from "@workspace/frontend-ui";
import { useEffect, useState } from "react";
import ConnectionButton from "../ConnectionButton";
import useConnectionClicked from "../ConnectionButton/hooks/useConnectionClicked";
import useTelegramLoader from "../ConnectionButton/hooks/useTelegramLoader";
import ToggleButton from "../ToggleButton";
import useSortedConnections from "../useSortedConnections";

type Props = {
  connections: SocialConnection[];
  otp?: string;
};

const SocialButtons: FC<Props> = ({ connections, otp }) => {
  const sortedConnections = useSortedConnections(connections);
  const { code } = useLanguage();
  const { userGeoCountryCode } = useUserGeoLocation();
  const isJP = userGeoCountryCode === "JP" || code === "ja";
  const mainButtons = sortedConnections?.slice(0, isJP ? 3 : 2) ?? [];
  const otherButtons = sortedConnections?.slice(isJP ? 3 : 2) ?? [];

  const handleConnectionClick = useConnectionClicked();
  const router = useRouter();
  const queryHandle = router.query.reg as Connection;
  const { handleClick: handleMetamaskRedirect } = useMetamaskButton();
  const [hasRun, setHasRun] = useState(false);
  const isTelegramLoaded = useTelegramLoader();

  useEffect(() => {
    if (queryHandle && !hasRun && isTelegramLoaded) {
      setHasRun(true);
      if (queryHandle === "metamask") {
        handleMetamaskRedirect();
        return;
      }
      handleConnectionClick({ handle: queryHandle, otp });
    }
  }, [
    queryHandle,
    otp,
    handleMetamaskRedirect,
    handleConnectionClick,
    hasRun,
    isTelegramLoaded,
  ]);

  return (
    <div
      className={cn(
        "grid w-full grid-flow-col grid-cols-2 gap-1",
        isJP && "grid-cols-3",
      )}
    >
      {mainButtons.map(({ handle }) => (
        <ConnectionButton
          key={handle}
          handle={handle as Connection}
          mainButton
          otp={otp}
        />
      ))}
      <ToggleButton>
        {otherButtons.map(({ handle }) => (
          <ConnectionButton
            key={handle}
            handle={handle as Connection}
            otp={otp}
          />
        ))}
      </ToggleButton>
    </div>
  );
};

export default SocialButtons;
